import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/trendelantero/BARRA-ESTABILIZADORA-1.png")